import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetReanudacionCATAByID = {
  status: number | null;
  statusText: string | null;
};

const useGetReanudacionCATAByID = () => {
  const [loadingGetReanudacionCATAByID, setLoadingReanudacionCATAByID] = useState(false);
  const [successGetReanudacionCATAByID, setSuccessReanudacionCATAByID] = useState(false);
  const [errorGetReanudacionCATAByID, setErrorReanudacionCATAByID] = useState<any>(null);
  const [dataGetReanudacionCATAByID, setDataReanudacionCATA] = useState<any>(null);

  const [statusGetReanudacionCATAByID, setStatusGetReanudacionCATAByID] =
    useState<StatusGetReanudacionCATAByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getReanudacionCATAByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingReanudacionCATAByID(true);
    setSuccessReanudacionCATAByID(false);
    setErrorReanudacionCATAByID(null);

    try {
      const res = await apiRecord.getSolicitudReanudacionByID(userId, prestacionId, id);

      setStatusGetReanudacionCATAByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessReanudacionCATAByID(true);
      setDataReanudacionCATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetReanudacionCATAByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorReanudacionCATAByID(err);
      console.error("Error en getReanudacionCATAByID:", err);

      throw err;

    } finally {
      setLoadingReanudacionCATAByID(false);
    }
  };

  return {
    getReanudacionCATAByID,
    loadingGetReanudacionCATAByID,
    successGetReanudacionCATAByID,
    errorGetReanudacionCATAByID,
    dataGetReanudacionCATAByID,
    statusGetReanudacionCATAByID
  };
};

export default useGetReanudacionCATAByID;
